import React from "react";
import { connect } from "react-redux";
import { Tabs } from "../../../components/Tabs";
import { withRouter } from "../../../utils/withRouter";
import { DashboardHeader } from "../../../components/Header";
import PerCenter from "../../../components/Reports/donation/PerCenter";
import PerCenterSite from "../../../components/Reports/donation/PerCenterSite";
import PerCenterGender from "../../../components/Reports/donation/PerCenterGender";
import DashboardBloodCollection from "../../../components/Reports/donation/dashboard";
import BloodCollectionReport from "../../../components/Reports/bloodCollection";
import { defineRole } from "../../../utils/handleAccessRoles";
import { ROLE_REPORTS } from "../../../constants/ROLES";
import { getStorage } from "../../../utils/storage";

class DonationReportsScreen extends React.Component {
  state = {
    user: {},
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });
  };

  render() {
// eslint-disable-next-line no-unused-vars
    const canReadReport = defineRole({
      roles: this.state.user?.accessRole | [],
      menu: ROLE_REPORTS,
      operation: "read",
    });
    let tabOptions = [
      {
        title: "Session Report",
        data: <BloodCollectionReport />,
      },
      {
        title: "Center Site",
        data: <PerCenterSite />,
      },
      {
        title: "Center",
        data: <PerCenter />,
      },
      {
        title: "Center and Gender",
        data: <PerCenterGender />,
      },
    ];

    // if (canReadReport) {
    tabOptions = [
      {
        title: "Dashboard",
        data: <DashboardBloodCollection />,
      },
      ...tabOptions,
    ];
    // }

    return (
      <div>
        <div className="card-dashboard-content">
          <div className="card-body">
            <div style={{ marginBottom: 16 }}>
              <div style={{ flex: 1 }}>
                <DashboardHeader title="Blood Collection Reports" />
              </div>
            </div>

            <Tabs options={tabOptions} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(withRouter(DonationReportsScreen));
